import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCurrentTenantSlug, getTenantApiUrl } from "../../tenantConfig";
import { trackBookAppointmentClicked } from "../../utils/analytics";
import defaultLogo from "./../../assets/dental logo.webp";
import "./Navbar.scss";

const Navbar = () => {
  const location = useLocation(); // Get current URL path
  const [logo, setLogo] = useState(defaultLogo); // State to store logo URL
  const [loading, setLoading] = useState(true);

  // Fetch logo from backend API
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const tenantSlug = getCurrentTenantSlug();
        const apiUrl = getTenantApiUrl(tenantSlug);
        const response = await fetch(`${apiUrl}/tenant/branding/`);
        if (response.ok) {
          const data = await response.json();
          console.log(data.data.logo)
          if (data.data.logo || data.data.logoUrl || data.data.branding?.logo) {
            setLogo(data.data.logo || data.data.logoUrl || data.data.branding?.logo);
          }
        } else {
          console.warn('Failed to fetch logo from API, using default logo');
        }
      } catch (error) {
        console.error('Error fetching logo:', error);
        // Keep using default logo on error
      } finally {
        setLoading(false);
      }
    };

    fetchLogo();
  }, []);

  const navbarItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Dental Checkup", path: "/dental-checkup" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <div className="main-nav">
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            {/* Logo */}
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="logo" height={60} width={60} />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                {navbarItems.map((navSingle, index) => (
                  <li className="nav-item" key={index}>
                    <Link
                      className={`nav-link ${
                        location.pathname === navSingle.path ? "active" : ""
                      }`}
                      to={navSingle.path}
                    >
                      {navSingle.name}
                    </Link>
                  </li>
                ))}
              </ul>

              <div className="theme-btn">
                <Link
                  to="/contact"
                  onClick={() => trackBookAppointmentClicked("Navbar")}
                >
                  Book appointment
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
